import { useEffect, useMemo } from "react"
import { markContactReplyThreadMessageAsRead } from "src/apis/contact/markContactReplyThreadMessageAsRead"
import { useAsyncSelector } from "src/hooks/useAsyncSelector"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { UnreadReplyCountCacheService } from "src/services/cache/UnreadReplyCountCacheService"

type Param = {
  replyThreadMessageId: string
  isRead: boolean
  itemType?: string
  organizationId?: string
  contactId?: string // 未読返信数の楽観的更新用
}

export const useMarkThreadMessageAsRead = ({ replyThreadMessageId, isRead, itemType, contactId }: Param) => {
  const { value: tokens } = useAsyncSelector(tokensState)
  const accessToken = useMemo(() => tokens?.accessToken, [tokens])

  useEffect(() => {
    const markAsRead = async () => {
      if (itemType === "RemovedReply") {
        if (accessToken) {
          if (replyThreadMessageId) {
            const result = await markContactReplyThreadMessageAsRead({ accessToken, replyThreadMessageId })

            // 既読API成功時、未読返信数のキャッシュを楽観的に減算
            if (result.isOk && contactId) {
              UnreadReplyCountCacheService.decrement(contactId, 1)
              console.log("[useMarkThreadMessageAsRead] Optimistically decremented unread reply count", { contactId })
            }
          }
        }
      } else {
        if (accessToken && !isRead) {
          const result = await markContactReplyThreadMessageAsRead({ accessToken, replyThreadMessageId })

          // 既読API成功時、未読返信数のキャッシュを楽観的に減算
          if (result.isOk && contactId) {
            UnreadReplyCountCacheService.decrement(contactId, 1)
            console.log("[useMarkThreadMessageAsRead] Optimistically decremented unread reply count", { contactId })
          }
        }
      }
    }

    markAsRead()
  }, [accessToken, isRead, replyThreadMessageId, itemType, contactId])
}
